<figcaption>
    @if (media.imageRetouched && locale.countryCode === "fr") {
        <p data-testid="imageRetouched" class="image-retouched paragraph-small" i18n="@@hermes.image_retouched"
            >Retouched</p
        >
    }
    @if (media.caption) {
        <p data-testid="caption" class="caption paragraph-small">{{ media.caption }}</p>
    }
    @if (media.credits) {
        <p data-testid="credits" class="credits paragraph-small">{{ media.credits }}</p>
    }
</figcaption>
